module.exports = __webpack_public_path__ + "media/images/gifts/books/sug_livros_8-1b99e683537f37bdc038a08a816f22fe.jpg";